import API from "../../../../global/api";
import {successFilled} from '../../accounts/account.actions';
export const getDivorce =(data1) => {
  return (dispatch) => {
    API.post(`/petitional/start-divorce`,data1).then((res) => {
      let data = res.data;
      data.message === "Divorce ID Already exist" ? window.localStorage.setItem("divorce_id", data1.divorce_id): window.localStorage.setItem("divorce_id", data.divorce_id);
      dispatch(successDivorce(data));
    });
  };
};

export const requestDivorce = (data) => {
  return {
    type: "REQUEST_DIVORCE",
  };
};
export const successDivorce = (data) => {
  return {
    type: "SUCCESS_DIVORCE",
    payload: data,
  };
};
export const errorDivorce = (data) => {
  return {
    type: "ERROR_DIVORCE",
    payload: data,
  };
};

export const postProfileInformation = (data) => {
    return (dispatch) => {
      API.put(`/petitional/update-data`,data).then((res) => {
        let data1 = res.data;
        dispatch(successPostData(data));
        dispatch(successFilled(data1));
      }).catch((error) => {
        dispatch(errorPostData())
            });
    };
  };

export const requestPostData = (data) => {
    return {
      type: "REQUEST_UPDATE_DATA",
    };
  };
  export const successPostData = (data) => {
    return {
      type: "SUCCESS_UPDATE_DATA",
      payload: data,
    };
  };
  export const errorPostData = (data) => {
    return {
      type: "ERROR_UPDATE_DATA",
      payload: data,
    };
  };
  
  
  export const getFormData = (data) => {
    return (dispatch) => {
       dispatch(requestFormData());
      API.post(`/petitional/get-all-data`,data).then((res) => {
        let data = [];
        data = res.data;
        dispatch(successFormData(data));
      }).catch((error)=> 
      dispatch(errorFormData()))
    };
  };

  export const requestFormData = () => {
    return {
      type: "REQUEST_PROFILE_FORM_DATA",
    };
  };
  export const successFormData = (data) => {
    return {
      type: "SUCCESS_PROFILE_FORM_DATA",
      payload: data,
    };
  };
  export const errorFormData = () => {
    return {
      type: "ERROR_PROFILE_FORM_DATA"
    };
  };


export const getStates = () => {
    return (dispatch) => {
      dispatch(requestStates());
      API.get(`/global/get-states`, {
        headers: {
        },
      }).then((res) => {
        let data = [];
        data = res.data;
        dispatch(successStates(data));
      });
    };
  };
  
  export const requestStates = () => {
    return {
      type: "REQUEST_STATES",
    };
  };
  export const successStates = (data) => {
    return {
      type: "SUCCESS_STATES",
      payload: data,
    };
  };
  export const errorStates = (data) => {
    return {
      type: "ERROR_STATES",
      payload: data,
    };
  };
  